<template>
  <div class="planDetailPage">
    <!-- 计划信息栏目 -->
    <section class="planInfoBox">
      <!-- 轮播 -->
      <Banner zoomWay="click" :slideList="slideList" :dblclickImage="dblclickImage" />
      <!-- 计划信息 -->
      <div class="planInfoList">
        <h3 class="planName">{{ detailData.loyaltyName }}</h3>
        <p v-if="detailData.planTag" class="planTag" style="margin-bottom:5px;">{{ detailData.planTag }}</p>
        <van-row class="moneyWeenyRow">
          <van-col span="20">
            <span class="moneyWeeny">购买期限 {{ detailData.buyStartTime }} - {{ detailData.buyEndTime }}</span>
          </van-col>
          <van-col span="4"></van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="moneyWeight" v-if="loyaltyType != 2 && customerCarId == -1 && detailData.priceTypeFlag === 3 && detailData.loyaltyTypeFlag === 2">
              意向金*：￥ {{ detailData.depositPrice || 0 }}
            </div>
            <div v-else>
              <span v-if="loyaltyType == 2" class="moneyWeight"
                >厂商建议零售价* ¥{{ detailData.uniformPrice || 0 }} {{ detailData.priceTypeFlag === 3 ? '起' : '' }}</span
              >
              <span v-else-if="isTyrePack" class="moneyWeight"> 
                厂商建议零售价* ¥{{ uniformPrice }}
              </span>
              <span v-else class="moneyWeight"
                >厂商建议零售价* ¥{{ detailData.uniformPrice || 0 }} {{ detailData.priceTypeFlag === 2 || detailData.priceTypeFlag === 3 ? '起' : '' }}</span
              >
            </div>
          </van-col>
        </van-row>
        <MsrpExplain sign="plan" />
      </div>
      <van-collapse v-if="!(detailData.loyaltyTypeFlag === 2)" v-model="planDiscrption" accordion>
        <van-collapse-item title="致友计划描述" name="1">
          <div class="accordionContent" v-html="description.content"></div>
        </van-collapse-item>
      </van-collapse>
      <div v-if="currentGoodsInfo?.loyaltyTypeFlag == 2 && currentGoodsInfo?.priceTypeFlag == 3">
        <van-field
          v-model="carInfo"
          readonly
          label="选择车辆"
          @click-right-icon="selectCar"
          :right-icon="currentGoodsInfo?.orderSource == 1 ? '' : 'arrow'"
          placeholder="请选择车辆"
        />
        <BrandSelect @setbrandInfo="setbrandInfo" :from="from" />
      </div>
      <!-- 经销商 -->
      <div class="dealerInfoList">
        <CurrentDealer @setLoading="setLoading">
          <template #colLabel>参与经销商</template>
        </CurrentDealer>
        <UseDealer @setLoading="setLoading" :isShowPhone="true" :param="applyDealerParam" @useclick="handleUseclick">
          <template #colLabel>可使用经销商</template>
          <template #currentDealer><span class="accordionContent">点击查看</span></template>
          <template #noDealer>查看可使用经销商</template>
          <template #afterName><span></span></template>
        </UseDealer>

        <!-- <van-row>
          <van-col span="6"
            ><span class="colLabel">适用车龄</span>
            <img @click="showCenterPopup" class="exclamationImg" src="../../../assets/images/exclamation.png" alt="" />
          </van-col>
          <van-col span="16"
            ><span class="colValue">{{ detailData.applyOld }}</span></van-col
          >
        </van-row> -->
      </div>
    </section>
    <div v-if="currentGoodsInfo?.loyaltyTypeFlag == 2 && currentGoodsInfo?.priceTypeFlag == 3 && brandInfo?.productItem && brandInfo?.productNo">
      <TyreDetails :productItem="brandInfo?.proItem" @on-get-uniformPrice="updateUniformPrice"  />
    </div>
    <van-collapse v-if="detailData.loyaltyTypeFlag === 2" v-model="planDiscrption" accordion>
      <van-collapse-item title="轮胎套餐计划描述" name="1">
        <div class="accordionContent" v-html="description.content"></div>
      </van-collapse-item>
    </van-collapse>
    <Divider text="专享权益" />
    <!-- 权益列表栏目 -->
    <div class="rightsCardBox" v-if="detailData.couponList && detailData.couponList.length > 0">
      <CouponList :couponList="detailData.couponList" :showArrow="true" @showCouponDetail="showCouponDetail" />
    </div>
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item title="使用限制说明" name="1">
        <div v-html="buyLimitDescription.content"></div>
      </van-collapse-item>
    </van-collapse>
    <!-- 底部按钮栏目 -->
    <GoodsBar
      :detailData="detailData"
      :from="from"
      :brandInfo="brandInfo"
      :isEnterShoppingCar="isEnterShoppingCar"
      :isEnable="isEnable && enable && eventOver"
      @toShoppingCar="toShoppingCar"
    />
    <!-- 页面底部计划详情弹窗 -->
    <CouponDetail :showPopUp="showCouponDetailNum" :datas="couponDetail" />
    <div v-show="isShowLoad" class="loadBox">
      <van-loading size="30px" vertical color="#fff"><span style="color:#fff">加载中...</span> </van-loading>
    </div>
    <ShowDiffCarInfo ref="refShowDiffCarInfo" @customEvent="setIsEnable" @customEventOver="setEventOver" />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch, onUnmounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ImagePreview, Dialog, Toast } from 'vant'
import Divider from '@/components/common/Divider'
import BrandSelect from '@/components/common/BrandSelect'
import TyreDetails from '@/components/common/TyreDetails'
import Banner from '@/components/common/Banner'
import GoodsBar from '@/components/common/GoodsBar'
import CouponList from '@/components/plan/CouponList'
import CouponDetail from '@/components/plan/CouponDetail'
import CurrentDealer from '@/components/dealer/CurrentDealer'
import UseDealer from '@/components/canUseDealer/CurrentDealer'
import ShowDiffCarInfo from '@/views/customer/car/ShowDiffCarInfo.vue'
import { getcheckTyrePackageUse } from '@/api/tyre'
import { getPlanDetail, getDealers } from '@/api/plan'
import { getMyDefault } from '@/api/car'
// import { trackLoyalty } from '@/api/pvuv'
import { showToast } from '@/util/couponCollection'
import MsrpExplain from '@/components/common/MsrpExplain.vue'
import { couponList } from '@/util/plan'
import { addEightHour, getDistance } from '@/util'
import { useStore } from 'vuex'
import { getCdoQrCodeInfoByqrInfoKey } from '@/api/directSales'

export default {
  name: 'planDetail',
  components: {
    Divider,
    BrandSelect,
    TyreDetails,
    Banner,
    CurrentDealer,
    UseDealer,
    CouponList,
    CouponDetail,
    GoodsBar,
    ShowDiffCarInfo,
    MsrpExplain
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const refShowDiffCarInfo = ref(null)
    let { loyaltyId, from, gsCode = '', boUserId = '', carInfo = '', loyaltyType, orderSource, qrcodeHistoryId, salesChannel, qrKey = '' } = route.query
    let { currentCarInfo, brandInfo } = store.state
    const carInfos =
      (currentCarInfo && currentCarInfo.plate ? currentCarInfo.plate : '') + ' ' + (currentCarInfo && currentCarInfo.model ? currentCarInfo.model : '')
    store.commit('SETLOYALTYID', loyaltyId)
    const state = reactive({
      loyaltyType, //1-致友计划 ;2-轮胎套餐计划
      currentGoodsInfo: null,
      orderSource,
      customerCarId: currentCarInfo?.id || -1,
      from,
      brandInfo: brandInfo,
      carInfo: carInfos.trim(),
      isShowLoad: false,
      planId: '',
      activeNames: '1',
      planDiscrption: '1',
      slideList: [],
      dblclickImage: [],
      isShowDealerPopup: false,
      centerPopupType: '',
      detailData: {},
      popupComponent: 'selectDealer',
      dealer: '',
      hasDealer: '',
      rightDetailData: {},
      showNum: 0,
      showCouponDetailNum: 0,
      popUpcontent: '',
      description: {
        title: '致友计划描述',
        content: ''
      },
      buyLimitDescription: {
        title: '使用限制说明',
        content: ''
      },
      couponDetail: [],
      buyStatus: '',
      isEnterShoppingCar: false,
      isEnable: false, //计划是否生效中--true
      dealerJoinPlanFlag: ['loyaltyList', 'shoppingCarList', 'scan'].includes(from),
      applyDealerParam: {},
      qrData: {},
      enable: true,
      eventOver: false,
      isTyrePack: false,
      uniformPrice: ''
    })
    store.dispatch('setDealerJoinPlanFlag', state.dealerJoinPlanFlag)
    // 设置gsCode，防止加载默认经销商
    gsCode && store.dispatch('setDealerInfo', { gs_code: gsCode })
    const setIsEnable = val => {
      state.enable = val
    }
    const setEventOver = val => {
      state.eventOver = val
    }

    const setbrandInfo = val => {
      state.brandInfo = val
    }
    const initByfrom = async () => {
      let data = await getMyDefault()
      if (data && data.id) {
        store.commit('SETMYDEFAULTCAR', data)
        state.customerCarId = data.id
      }
      const isScan = from === 'scan' || from === 'QRcode'
      // isSperate 是否运营
      const isFreeze = isScan && gsCode
      store.commit('SETDEALERfREEZEFLAG', isFreeze)
      if (isFreeze) {
        getDealerFn(gsCode)
      }
      console.log('currentCarInfo', currentCarInfo, store.state.myDdefaultCar)
      if (currentCarInfo?.intention) {
        state.carInfo = '暂不选择车辆'
      }
      if (state.customerCarId == -1) {
        state.carInfo = '暂不选择车辆'
      }
      if (carInfo) {
        //  从生成车辆信息过来
        refShowDiffCarInfo.value.createCarInfo(carInfo)
        store.commit('SETBOUSERINFO', {
          id: boUserId
        })
      } else {
        state.eventOver = true
      }
      // if(isScan){
      //   console.log(myDdefaultCar)
      //   refShowDiffCarInfo.value.createCarInfo(myDdefaultCar)
      //    store.commit('SETBOUSERINFO', {
      //     id: boUserId
      //   })
      // }
      // let type = isScan ? 'QR_CODE' : 'UNDEFINED'
      // trackLoyalty(`/wx/promotion/events/${loyaltyId}/stats`, { event_source: type })
    }
    // 选择车辆
    const selectCar = () => {
      // sessionStorage.setItem(
      //   'showType',
      //   JSON.stringify({
      //     showPopUp: true,
      //     currentType: state.currentTypeVal
      //   })
      // )
      router.push({ path: '/carList', query: { loyaltyId: loyaltyId, qrcodeHistoryId: qrcodeHistoryId || '', callBack: true, event: '切换车辆' } })
    }
    const handleUseclick = () => {
      console.log('handleUseclick')
      if (!state.applyDealerParam || !state.applyDealerParam.loyaltyId || !state.applyDealerParam.gsCode) {
        showToast('请先选择参与经销商')
        return
      }
    }
    const getDealerFn = async gsCode => {
      try {
        let { lat, lng } = store.state.position
        let { list = [] } = await getDealers({
          gsCode,
          loyaltyId,
          latitude: lat,
          longitude: lng
        })
        const dealerInfo = list[0] || {}
        dealerInfo.distance = getDistance(dealerInfo.distance)
        let _gsCode = dealerInfo.gs_code || dealerInfo.gsCode
        dealerInfo.gs_code = dealerInfo.gsCode = _gsCode
        store.dispatch('setLoyaltyDealerInfo', dealerInfo)
      } catch (e) {
        showToast(e.message, '获取经销商详情失败')
        store.dispatch('setLoyaltyDealerInfo', {})
      }
    }
    onUnmounted(() => {
      store.commit('SETDEALERfREEZEFLAG', false)
      store.commit('SETLOYALTYID', '')
    })
    const setLoading = data => {
      state.isShowLoad = data
    }
    const showCouponDetail = val => {
      state.couponDetail = [val]
      state.showCouponDetailNum += 1
    }
    const showImg = index => {
      ImagePreview({
        images: state.images,
        startPosition: index
      })
    }
    // const clickGoodBtn=(val)=>{
    //     sessionStorage.setItem(
    //     'showType',
    //     JSON.stringify({
    //       showPopUp: true,
    //       currentType: val.type
    //     })
    //   )
    // }
    const toShoppingCar = () => {
      router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
    }
    const showCenterPopup = () => {
      Dialog.alert({
        message: `车龄计算方式为，以三包日期为准，未满N年算N年，满N年算N+1年。\n例：若三包日期为2019.1.1，则2019.1.2时车龄为1年，2010.1.1时车龄为2年。详情请联系经销商确认。`
      })
    }
    const showDealerPopup = () => {
      state.isShowDealerPopup = true
    }
    const closeRightPopup = () => {
      state.rightDetailData = {}
    }
    const checkTyrePackageUse = async () => {
      const isScan = from === 'scan' || from === 'QRcode'
      if (isScan) return
      if (state.goodsInfo?.priceTypeFlag == 3 && state.goodsInfo?.loyaltyTypeFlag == 2) {
        let params = {
          customerCarId: currentCarInfo?.id,
          loyaltyId,
          brand: state.brandInfo?.brand || '',
          spec: state.brandInfo?.spec || '',
          productNo: state.brandInfo?.productNo || ''
        }
        let res = await getcheckTyrePackageUse(params)
        if (res.errorMsg) {
          Toast(res.errorMsg)
        }
      }
    }
    // 获取致友计划详情信息
    const getPlanDetailFn = async params => {
      if (!params.loyaltyId) return
      let data = await getPlanDetail(params)
      data.buyStartTime = addEightHour(data.buyStartTime, 'day', '.')
      data.buyEndTime = addEightHour(data.buyEndTime, 'day', '.')
      data.applyOld = data.applyOld ? data.applyOld.replace(/,/g, '/') : ''
      data.couponList = couponList(data.couponList)

      // 权益用完前是否允许继续购买
      const canContinueBuyingBeforeUseUp = data.buyStatusFlag === 0

      state.isTyrePack = data.loyaltyTypeFlag === 2 && from === 'TirePackage'
      // 轮胎情况java单独增强了buyAmountLimit字段，此字段可以cover- buyStatusFlag控制，所以这里仅保留非轮胎包情况的逻辑
      if(!state.isTyrePack) {
        data.buyAmountLimit = canContinueBuyingBeforeUseUp? data.buyAmountLimit : 1
      }
      state.detailData = data
      state.uniformPrice = data.uniformPrice + '起'
      state.isEnterShoppingCar = from === 'scan' || from === 'QRcode' ? false : !!data.cartEnableStatusFlag
      state.isEnable = data.activeStatusFlag === 2
      //     store.dispatch('setCurrentCarInfo', {
      //     id:-1,
      //     intention:true
      //   })
      // }
      for (const item of data.activityImage) {
        state.slideList.push(item.imageUrl)
        state.dblclickImage.push(item.dblclickImage ? item.dblclickImage : item.imageUrl)
      }
      state.description = {
        title: '致友计划描述',
        content: data.description
      }
      state.buyLimitDescription = {
        title: '使用限制说明',
        content: data.buyLimitDescription
      }
      store.dispatch('setCurrentGoodsInfo', {
        img: data.planImage && data.planImage[0] && data.planImage[0].imageUrl,
        name: data.loyaltyName,
        factoryGuidePrice: data.factoryGuidePrice,
        uniformPrice: data.uniformPrice,
        depositPrice: data.depositPrice,
        priceTypeFlag: data.priceTypeFlag,
        loyaltyTypeFlag: data.loyaltyTypeFlag,
        id: data.id,
        loyaltyId: data.id,
        scanTypeFlag: from == 'scan' ? 3 : from == 'QRcode' ? 2 : 1,
        // 商品类别{1:计划2:轮胎},此处写死为计划
        // productType: data.priceTypeFlag==3 && data.loyaltyTypeFlag==2 ? 4:1,
        productType: 1,
        loyaltyType: loyaltyType || data.loyaltyType,
        orderSource: orderSource || 0,
        qrcodeHistoryId: loyaltyType == 2 && qrcodeHistoryId != 'null' ? qrcodeHistoryId : '',
        type: from == 'scan' ? 2 : null,
        boUserId,
        qrData: state.qrData
      })
      let { currentGoodsInfo } = store.state
      state.currentGoodsInfo = currentGoodsInfo
      if (currentGoodsInfo.orderSource == 1 && data.priceTypeFlag == 3 && data.loyaltyTypeFlag == 2) {
        let productItem = data.tyrePartList?.productNo + ' ' + data.tyrePartList?.tyrePart + ' ' + data.tyrePartList?.msrp
        let obj = { brand: data.brand, spec: data.spec, productNo: data.tyrePartList.productNo, proItem: data.tyrePartList, productItem }
        store.commit('SETBRANDINFO', obj)
      }
      let loyaltyDealerInfo = store.state.loyaltyDealerInfo
      if (loyaltyDealerInfo) {
        state.applyDealerParam = {
          loyaltyId,
          gsCode: loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
        }
      }
    }
    const selectResultFn = val => {
      state.isShowDealerPopup = false
      state.dealer = val
      if (val && val.text) {
        state.hasDealer = true
      }
    }
    watch(
      () => store.state.currentGoodsInfo,
      n => {
        state.goodsInfo = n
      }
    )
    watch(
      () => store.state.brandInfo,
      n => {
        state.brandInfo = n
      },
      { deep: true }
    )
    watch(
      () => store.state.currentCarInfo,
      n => {
        if (carInfo || n) {
          const carInfos = (n && n.plate ? n.plate : '') + ' ' + (n && n.model ? n.model : '')
          state.carInfo = carInfos.trim()
        }
        if (n) {
          state.customerCarId = n.id
        }
      },
      { deep: true }
    )
    watch(
      () => store.state.position,
      (n, o) => {
        console.log('store.state.position.lat', n)
        // initByfrom()
        let nLat = (n && n.lat) || ''
        let oLat = (o && o.lat) || ''
        let { loyaltyDealerInfo: dealerInfo } = store.state
        let gs_code = dealerInfo.gsCode || dealerInfo.gs_code
        let _gsCode = gsCode || gs_code
        nLat && nLat !== oLat && _gsCode && !dealerInfo.distance && getDealerFn(_gsCode)
      },
      { deep: true }
    )
    watch(
      () => store.state.loyaltyDealerInfo,
      v => {
        let gsCode = v.gsCode || v.gs_code
        let position = store.state.position
        let nLat = (position && position.lat) || ''
        state.applyDealerParam = {
          loyaltyId,
          gsCode
        }
        if (!v.distance && gsCode && nLat) {
          getDealerFn(gsCode)
        }
      },
      { deep: true }
    )

    const updateUniformPrice = (newPrice) => {
      state.uniformPrice = newPrice
    }

    onMounted(async () => {
      let qrData = {}
      let qrCarInfo = {}
      if (salesChannel && qrKey) {
        try {
          //cdoOTR扫码
          qrData = await getCdoQrCodeInfoByqrInfoKey({ qrInfoKey: qrKey })
          const {
            productId,
            gsCode: _gsCode,
            baumuster = '',
            fin = '',
            vin = '',
            plate = '',
            model = '',
            threeGuaranteesDate = '',
            productAmount,
            firstRegistrationDate = ''
          } = qrData
          state.qrData = qrData
          loyaltyId = productId
          store.commit('SETLOYALTYID', productId)
          gsCode = _gsCode
          state.orderSource = orderSource = 1
          state.qrcodeHistoryId = qrcodeHistoryId = qrData.qrcodeHistoryId
          state.loyaltyType = loyaltyType = qrData.loyaltyType
          qrCarInfo = { fin, vin, plate, baumuster, model, threeGuaranteesDate, firstRegistrationDate, isDefault: true }
          carInfo = JSON.stringify(qrCarInfo)
          store.dispatch('setCurrentCarInfo', qrCarInfo)
          store.commit('SETSTEPPEROPTION', {
            ...store.state.stepperOption,
            value: productAmount
          })
        } catch (e) {
          // showToast(e.message, '获取二维码信息失败')
          showToast(e.message, {
            defaultMsg: '获取二维码信息失败',
            type: 'fail',
            duration: 4000,
            position: 'middle',
            overlay: true,
            onOpened: () => {
              router.replace({ path: '/' })
            },
            onClose: () => {
              // router.replace({ path: '/' })
            }
          })
          return false
        } finally {
          console.log('getShopInfoByqrInfoKey--finally')
        }
      }
      await initByfrom()
      await getPlanDetailFn({
        customerCarId: currentCarInfo?.id || state.customerCarId,
        loyaltyId,
        qrcodeHistoryId: qrcodeHistoryId != 'null' ? qrcodeHistoryId : '',
        type: from == 'scan' ? 2 : null
      })
      checkTyrePackageUse()
    })
    return {
      ...toRefs(state),
      setbrandInfo,
      selectCar,
      showImg,
      showCenterPopup,
      closeRightPopup,
      checkTyrePackageUse,
      getPlanDetailFn,
      showDealerPopup,
      selectResultFn,
      showCouponDetail,
      // clickGoodBtn,
      toShoppingCar,
      setLoading,
      refShowDiffCarInfo,
      handleUseclick,
      setIsEnable,
      setEventOver,
      updateUniformPrice
    }
  }
}
</script>

<style lang="scss" scoped>
.planDetailPage {
  background-color: #f5f5f5;
  text-align: left;
  padding-bottom: calc(6px + constant(safe-area-inset-bottom));
  padding-bottom: calc(6px + env(safe-area-inset-bottom));
  .mySwipe {
    margin-bottom: 18px;
    img {
      width: 100%;
      height: 210px;
    }
  }
  .planInfoList {
    padding: 12px 20px;
    background-color: #fff;
    margin-bottom: 8px;
  }
  .dealerInfoList {
    padding: 18px 20px 10px;
    background-color: #fff;
  }
}
// 计划信息样式
.planInfoList {
  h3 {
    font-size: 18px;
    color: #333;
    font-weight: 700;
    margin-bottom: 12px;
  }
  .moneyWeenyRow {
    margin-bottom: 10px;
  }
  .moneyWeeny {
    font-size: 12px;
    color: #666;
  }
  .moneyWeight {
    font-size: 16px;
    color: #3088c5;
    font-weight: bold;
    line-height: 30px;
  }
}
.exclamationImg {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

// 经销商样式
.dealerInfoList {
  .label {
    font-size: 14px;
    color: #333;
    line-height: 30px;
  }

  .van-divider {
    margin: 8px 0;
  }
}

// 专享权益
.rightsCardBox {
  padding: 10px 20px;
  background-color: #f5f5f5;
}

.colLabel,
.colValue {
  font-size: 14px;
  color: #333;
  line-height: 30px;
  vertical-align: middle;
}
.accordionContent {
  width: 100%;
  :deep(p) {
    word-break: break-all;
  }
}
.loadBox {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding-top: 250px;
  background-color: rgba($color: #000000, $alpha: 0.4);
}
</style>
